/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateParameterMutationVariables = {
    parameter: string;
    value?: string | null | undefined;
};
export type UpdateParameterMutationResponse = {
    readonly setParameter: {
        readonly parameterId: string;
    };
};
export type UpdateParameterMutation = {
    readonly response: UpdateParameterMutationResponse;
    readonly variables: UpdateParameterMutationVariables;
};



/*
mutation UpdateParameterMutation(
  $parameter: String!
  $value: String
) {
  setParameter(parameter: $parameter, value: $value) {
    parameterId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "parameter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "parameter",
        "variableName": "parameter"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "Parameter",
    "kind": "LinkedField",
    "name": "setParameter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "parameterId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateParameterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateParameterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e2c4ba974b8ebca8e859daaa3e14c042",
    "id": null,
    "metadata": {},
    "name": "UpdateParameterMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateParameterMutation(\n  $parameter: String!\n  $value: String\n) {\n  setParameter(parameter: $parameter, value: $value) {\n    parameterId\n  }\n}\n"
  }
};
})();
(node as any).hash = '39618ea012d52c6f213fe92f6eaa959d';
export default node;
